export const DEFAULT_DATE_FORMAT_ISO = 'YYYY-MM-DD';
export const DEFAULT_DATE_FORMAT_UI = 'MM/DD/YYYY';
